<template>
  <div class="card">
    <div class="p-1">
      <div v-if="inProgress" class="loading-state">
        <div class="custom-loader">
          <div class="loader-circle"/>
          <div class="loader-circle"/>
          <div class="loader-circle"/>
          <div class="loader-circle"/>
        </div>
        <p class="loading-text">Loading...</p>
      </div>
      <div v-else class="card-body overflow-auto p-1" style="max-height: 350px">
        <div v-if="subscriptionPackages?.length">
          <!-- Sticky header -->
          <div class="row g-1 mb-1" style="position: sticky; top: -5px; z-index: 1;">
            <div class="col-8">
              <span style="font-size: 0.75rem; font-weight: 500; padding-left: 4px;color: #000;">Subscription</span>
            </div>
            <div class="col-4">
              <span style="font-size: 0.75rem; font-weight: 500; padding-left: 4px;color: #000;">Valid until</span>
            </div>
          </div>

          <div class="col-12" v-for="(nth, i) in subscriptionPackages" :key="i">
            <div class="row g-1">
              <div class="col-8">
                <div  style="padding: 4px; color:#718096; font-size: 0.6875em; margin-bottom: 0.5rem; text-align: start; white-space: normal; word-break: break-word;">
                  {{ nth.elementName }}
                </div >
              </div>
              <div class="col-4">
                <div  class="ellipsis-text"
                      style="padding: 4px; color:#718096; font-size: 0.6875em; margin-bottom: 0.5rem; text-align: start">
                  {{ nth.endDate }}
                </div >
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>No current subscriptions.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import {
  SUBSCRIPTION_INFO,
  getSubscriptionInfo,
  inProgress
} from "../../composables/subscription";
const subscriptionPackages = computed(() => {
  const result = [];

  SUBSCRIPTION_INFO?.parentSubscriptionPackages?.forEach((pkg) => {
    const endDate = pkg.effectiveDate != null ? pkg.effectiveDate[1] : new Date();
    const cleanElementName = pkg.packageName ? pkg.packageName.replace(/\s*\([^)]*\)/g, '') : '';

    result.push({
      element: pkg.id,
      endDate: endDate,
      elementName: cleanElementName.trim(),
      serviceType: pkg.serviceType,
      elements: pkg.elements ?? []
    });
  });

  result.sort((a, b) => {
    const nameCompare = a.elementName.localeCompare(b.elementName);
    if (nameCompare !== 0) return nameCompare;
    return new Date(b.endDate) - new Date(a.endDate);
  });

  return result;
});

onMounted(async () => {
  if (!SUBSCRIPTION_INFO?.subscriptionPackages) await getSubscriptionInfo(false);
  console.log(SUBSCRIPTION_INFO, 'SUBSCRIPTION_INFO')
});
</script>

<style lang="scss" scoped>
@import url("../../assets/styles/home-page-styles.scss");
small {
  font-size: 0.8125rem !important;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.blue-text {
  color: #000 !important;
}

@media (max-width: 382px) {
  .ellipsis-text {
    width: 90%;
  }
}
.loading-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 100%;
  gap: 1.5rem;
}

.custom-loader {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.loader-circle {
  width: 12px;
  height: 12px;
  background-color: #00213b;
  border-radius: 50%;
  animation: loader-bounce 1.4s ease-in-out infinite both;

  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }
  &:nth-child(3) { animation-delay: 0s; }
  &:nth-child(4) { animation-delay: 0.16s; }
}

@keyframes loader-bounce {
  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
  40%           { transform: scale(1); opacity: 1; }
}

/* Empty State */
.empty-state {
  padding: 2rem 1rem;
  text-align: center;
}

.empty-state p {
  color: #718096;
  font-size: 0.9rem;
  margin: 0;
}

.loading-text {
  color: #00213b;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  opacity: 0.8;
}
</style>
